<template>
<div>
      <div class="card" style="border-radius: 5px;  width:600px; display:inline-block;" v-if="getConfirmation">
        <header class="card-header">
          <p class="card-header-title">
            削除してもよろしいでしょうか
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたMarkdownを復元することはできません。
              削除の際は細心の注意を払って削除をお願いいたします。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="noDelete()">いいえ</a>
          <a class="card-footer-item" @click="deleteText(nowID)">はい</a>
        </footer>


      </div>

      <div class="card" style="border-radius: 5px;  width:500px; display:inline-block;" v-if="!getConfirmation">
 
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
            削除しました
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="releaseConfircation()">OK
          </a>
        </footer>
      </div>
</div>
   
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalDeleteMarkdown',
  componentName: 'ModalDeleteMarkdown',
  components: {
  },
  props: {
    nowID:"",
    isConfirmation:""
  },
  data () {
    return {
      isFileUp:false,
      getConfirmation:true
    }
  },
  methods: {
    deleteText(nowID){
      console.debug('*** Start *** deleteText')
      this.$store.dispatch('tools/deleteText',
        {
          'contents_id': this.nowID
        }
      )
      this.getConfirmation = false
      console.debug('*** End *** deleteText')
    },
    noDelete () {
      console.debug('*** Start *** deleteChatBot')
      this.$store.dispatch('tools/getText')
      this.$parent.close()
      console.debug('*** End *** deleteChatBot')
    },
    releaseConfircation () {
      console.debug('*** Start *** deleteChatBot')
      this.$store.dispatch('tools/getText')
      this.$emit('deleteMessage', 0)
      this.$parent.close()
      console.debug('*** End *** deleteChatBot')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Release/ModalDeleteMarkdown.vue